import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OccEndpointsService, UserIdService } from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMap, take } from 'rxjs/operators'
import { EbProductPrice, EbProductPriceItem } from '../../interfaces/eb-product.interface'

@Injectable()
export class EbPricesAdapter {
  constructor(
    private readonly http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    private readonly userIdService: UserIdService
  ) {}

  fetchPrices(product: EbProductPriceItem[]): Observable<EbProductPrice> {
    return this.userIdService.getUserId().pipe(
      take(1),
      map(userId =>
        this.occEndpoints.buildUrl('prices', {
          urlParams: { userId }
        })
      ),
      switchMap(url => this.http.post<EbProductPrice>(url, product)),
      catchError(() => of({} as EbProductPrice))
    )
  }
}
